const TOKEN_KEY = "itpmng_datadog_token";
const SITE_KEY = "itpmng_datadog_site";
const DEFAULT_SITE = "datadoghq.com";

export interface DatadogCreds {
  token: string;
  site: string;
}

// App-wide (not per-account) Datadog credential, stored in sessionStorage —
// cleared when the tab closes. The token never leaves the browser except as a
// per-request header to the API proxy; it is never persisted server-side.
export const getDatadogCreds = (): DatadogCreds | null => {
  const token = sessionStorage.getItem(TOKEN_KEY);
  if (!token) return null;
  const site = sessionStorage.getItem(SITE_KEY) || DEFAULT_SITE;
  return { token, site };
};

export const setDatadogCreds = ({ token, site }: DatadogCreds): void => {
  sessionStorage.setItem(TOKEN_KEY, token);
  sessionStorage.setItem(SITE_KEY, site || DEFAULT_SITE);
};

export const clearDatadogCreds = (): void => {
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(SITE_KEY);
};

export const DATADOG_DEFAULT_SITE = DEFAULT_SITE;
